
<template>
	<div class="app">
		<app-header v-if="$route.path != '/api-documentation'"></app-header>
		  <router-view /> 
		<app-footer v-if="$route.path != '/api-documentation'"></app-footer>
	</div>
</template> 
<!-- <style scoped>
  @Import '/../../static/website/css/bootstrap.min.css';
  @Import '/../../static/website/css/style.css'; 
  @Import '/../../static/website/css/responsive.css';
</style> -->
<script> 
import Header from './shared/header'
import Footer from './shared/footer'
import '../../../static/website/js/bootstrap.min.js'
import '../../../static/website/js/custom.js'

export default {
  name: 'Home',
    data () {
	    return {

	    }
    }, 
    components: {
      appHeader: Header,
      appFooter: Footer
    },
   
    
}  
</script>


// WEBPACK FOOTER //
// src/components/website/index.vue